export const getters = {
  permissions (state) {
    return state.permissions
  },
  permission (state) {
    return state.permission
  },  
  pagination(state){
    return state.pagination
  }
}
